import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { DeliveryTypeSelector } from 'src/components/Selectors/DeliveryTypeSelector';
import { ContentId } from 'src/utils/constants/contentId';
import { DeliveryType } from 'src/WebApiController';

type DeliveryTypeFilter = {
  deliveryType: DeliveryType | null;
};

export const useDeliveryTypeFilters = <TFilter extends DeliveryTypeFilter>({
  query,
  setQuery,
  allowCustomDeliveryType = true,
}: {
  query: TFilter;
  setQuery: (query: TFilter) => void;
  allowCustomDeliveryType?: boolean;
}): FilterToolbarItem => {
  return {
    filterId: 'deliveryType' as FilterToolbarItemId,
    labelContentId: ContentId.Delivery,
    filterQueryKeys: ['deliveryType'] as FilterToolbarItemId[],
    filterItem: (
      <DeliveryTypeSelector
        style={{ width: '100%' }}
        value={query.deliveryType}
        enableEmptySelection
        onChange={(deliveryType) => {
          if (deliveryType !== query.deliveryType) {
            setQuery({
              ...query,
              deliveryType: deliveryType,
            });
          }
        }}
        allowCustomDeliveryType={allowCustomDeliveryType}
      />
    ),
  };
};
